// To implement this properly we may need to add a parameter.
// If so, then we may need to wrap `getWillShowNav4` in a hook.
// However, as this is the only stage and phase to require route matching,
// we should first explore if we can implement without a parameter.
export const getIsRouteExcludedForDogfoodingPhase1 = () => false;
